<!-- /home/tanyaradzwa/Projects/aivor-cost-management-system/source/frontend/src/app/components/UI/tooltip/tooltip.component.html -->
<span class="info-icon" (click)="toggleTooltip($event)">
  <ng-content select="[icon]"></ng-content>
  <div class="tooltip" [class.show]="isVisible">
    <ng-content select="[content]"></ng-content>
  </div>
</span>
